/*
  Clamps a block of text and reveals it on demand.

  Two sections on the collection page need it (the header description and the
  brand block), so both request this file. The IIFE plus the registry check make
  a second load a no-op instead of a redeclaration error.
*/
(() => {
  if (customElements.get('collapsible-description')) return;

  class CollapsibleDescription extends HTMLElement {
    constructor() {
      super();
      this.content =
        this.querySelector('.collection-header__desc-content') ||
        this.querySelector('.collapsible-description__content');
      this.toggle =
        this.querySelector('.collection-header__read-more') ||
        this.querySelector('.collapsible-description__toggle');
      if (!this.content || !this.toggle) return;
      this.clampedClass = this.content.classList.contains('collection-header__desc-content')
        ? 'collection-header__desc-content--clamped'
        : 'collapsible-description__content--clamped';
      this.setup();
    }

    setup() {
      this.content.classList.add(this.clampedClass);
      if (!this.dataset.open) this.dataset.open = 'false';
      requestAnimationFrame(() => this.checkOverflow());
      this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
      this.resizeObserver.observe(this.content);
      this.toggle.addEventListener('click', () => this.toggleOpen());
    }

    checkOverflow() {
      if (this.dataset.open === 'true') return;
      const isOverflowing = this.content.scrollHeight - 1 > this.content.clientHeight;
      this.toggle.dataset.visible = String(isOverflowing);
    }

    toggleOpen() {
      const isOpen = this.dataset.open === 'true';
      this.dataset.open = String(!isOpen);
      this.content.classList.toggle(this.clampedClass, isOpen);
    }
  }

  customElements.define('collapsible-description', CollapsibleDescription);
})();
